module.exports = __webpack_public_path__ + "static/media/bsc2016_work.21adeca1.png";